(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-editorial"] && !Shopify.designMode) return;
  try {
    
  class AboutGallery extends HTMLElement {
    #dragging = false;
    #startX = 0;
    #scrollStart = 0;
    #moved = false;

    connectedCallback() {
      this.gallery = this.querySelector('.about-editorial__gallery');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      if (!this.gallery) return;

      this.prevBtn?.addEventListener('click', this.#scrollPrev);
      this.nextBtn?.addEventListener('click', this.#scrollNext);
      this.gallery.addEventListener('scroll', this.#updateArrows, { passive: true });

      this.gallery.addEventListener('mousedown', this.#onPointerDown);
      document.addEventListener('mousemove', this.#onPointerMove);
      document.addEventListener('mouseup', this.#onPointerUp);
      this.gallery.addEventListener('click', this.#preventClickAfterDrag, true);

      this.#updateArrows();
    }

    disconnectedCallback() {
      this.prevBtn?.removeEventListener('click', this.#scrollPrev);
      this.nextBtn?.removeEventListener('click', this.#scrollNext);
      this.gallery?.removeEventListener('scroll', this.#updateArrows);
      this.gallery?.removeEventListener('mousedown', this.#onPointerDown);
      document.removeEventListener('mousemove', this.#onPointerMove);
      document.removeEventListener('mouseup', this.#onPointerUp);
      this.gallery?.removeEventListener('click', this.#preventClickAfterDrag, true);
    }

    #getStep() {
      const card = this.gallery.querySelector('.about-editorial__card');
      if (!card) return 200;
      const gap = parseFloat(getComputedStyle(this.gallery).gap) || 0;
      return card.offsetWidth + gap;
    }

    #scrollPrev = () => {
      this.gallery.scrollBy({ left: -this.#getStep(), behavior: 'smooth' });
    };

    #scrollNext = () => {
      this.gallery.scrollBy({ left: this.#getStep(), behavior: 'smooth' });
    };

    #updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.gallery;
      const atStart = scrollLeft <= 4;
      const atEnd = scrollLeft >= scrollWidth - clientWidth - 4;

      if (this.prevBtn) {
        this.prevBtn.hidden = atStart;
      }
      if (this.nextBtn) {
        this.nextBtn.hidden = atEnd;
      }
    };

    #onPointerDown = (e) => {
      if (e.button !== 0) return;
      this.#dragging = true;
      this.#moved = false;
      this.#startX = e.clientX;
      this.#scrollStart = this.gallery.scrollLeft;
      this.gallery.style.scrollSnapType = 'none';
      this.gallery.style.scrollBehavior = 'auto';
      this.gallery.style.cursor = 'grabbing';
      this.gallery.style.userSelect = 'none';
    };

    #onPointerMove = (e) => {
      if (!this.#dragging) return;
      const dx = e.clientX - this.#startX;
      if (Math.abs(dx) > 3) this.#moved = true;
      this.gallery.scrollLeft = this.#scrollStart - dx;
    };

    #onPointerUp = () => {
      if (!this.#dragging) return;
      this.#dragging = false;
      this.gallery.style.scrollSnapType = '';
      this.gallery.style.scrollBehavior = '';
      this.gallery.style.cursor = '';
      this.gallery.style.userSelect = '';
    };

    #preventClickAfterDrag = (e) => {
      if (this.#moved) {
        e.preventDefault();
        e.stopPropagation();
        this.#moved = false;
      }
    };
  }

  if (!customElements.get('about-gallery')) {
    customElements.define('about-gallery', AboutGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  const nav = document.querySelector('.collection-header__sizes');
  if (nav) {
    const filterOption = nav.dataset.filterOption || 'Size';
    const buttons = nav.querySelectorAll('.collection-header__size');
    const grid = document.querySelector('.collection-products');

    /* Mobile dropdown elements */
    const trigger = document.querySelector('.collection-header__select-trigger');
    const dropdown = document.querySelector('.collection-header__select-dropdown');
    const selectLabel = document.querySelector('.collection-header__select-label');
    const options = document.querySelectorAll('.collection-header__select-option');

    function syncMobileSelect(size) {
      if (!selectLabel) return;
      options.forEach((opt) => {
        const isActive = opt.dataset.size === size;
        opt.classList.toggle('collection-header__select-option--active', isActive);
        if (isActive) selectLabel.textContent = opt.textContent.trim();
      });
    }

    function activateSize(size) {
      /* Update desktop buttons */
      buttons.forEach((b) => b.classList.remove('collection-header__size--active'));
      const activeBtn = Array.from(buttons).find((b) => b.dataset.size === size);
      if (activeBtn) activeBtn.classList.add('collection-header__size--active');

      /* Sync mobile */
      syncMobileSelect(size);

      /* Update URL without reload */
      const url = new URL(window.location.href);
      if (size === 'all') {
        url.searchParams.delete('size');
      } else {
        url.searchParams.set('size', size);
      }
      history.replaceState(null, '', url);

      if (grid) filterGrid(size, grid, filterOption);
    }

    // Read initial filter from URL
    const params = new URLSearchParams(window.location.search);
    const initialSize = params.get('size');
    if (initialSize && grid) {
      activateSize(initialSize);
    }

    /* Desktop tab clicks */
    nav.addEventListener('click', (e) => {
      const btn = e.target.closest('.collection-header__size');
      if (!btn) return;
      activateSize(btn.dataset.size);
    });

    /* Mobile dropdown toggle */
    if (trigger && dropdown) {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !isOpen);
        dropdown.classList.toggle('collection-header__select-dropdown--open', !isOpen);
      });

      options.forEach((opt) => {
        opt.addEventListener('click', () => {
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('collection-header__select-dropdown--open');
          activateSize(opt.dataset.size);
        });
      });

      /* Close on outside click */
      document.addEventListener('click', (e) => {
        if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('collection-header__select-dropdown--open');
        }
      });
    }
  }

  function filterGrid(size, grid, filterOption) {
    const items = grid.querySelectorAll('.collection-products__item');
    let visibleIndex = 0;

    items.forEach((item) => {
      const productSizes = item.dataset.sizes || '';
      const sizesArray = productSizes.split(',').map((s) => s.trim());

      if (size === 'all' || sizesArray.includes(size)) {
        item.style.display = '';
        visibleIndex++;
        const numberEl = item.querySelector('.pci__number');
        if (numberEl) {
          numberEl.textContent = String(visibleIndex).padStart(2, '0');
        }
      } else {
        item.style.display = 'none';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var watermarks = document.querySelectorAll('.lookbook-story__logo-watermark');
    if (!watermarks.length) return;

    var BASE_RADIUS = 100;
    var FADE_DELAY = 1000;
    var FADE_DURATION = 800;
    var MASK_SCALE = 0.3;
    var hoverSupported = window.matchMedia('(hover: hover)').matches;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    watermarks.forEach(function (el) {
      observer.observe(el);
      if (!hoverSupported) return;

      var glow = el.querySelector('.lookbook-logo__glow');
      var starGlow = el.querySelector('.lookbook-logo__star-glow');
      var fill = el.querySelector('.lookbook-logo__fill');
      var starFill = el.querySelector('.lookbook-logo__star-fill');
      if (!glow) return;

      var strokeLayers = [glow];
      if (starGlow) strokeLayers.push(starGlow);
      var fillLayers = [];
      if (fill) fillLayers.push(fill);
      if (starFill) fillLayers.push(starFill);
      var allLayers = strokeLayers.concat(fillLayers);

      /* offscreen canvases for masks */
      var sCvs = document.createElement('canvas');
      var sCtx = sCvs.getContext('2d');
      var fCvs = document.createElement('canvas');
      var fCtx = fCvs.getContext('2d');
      var mW = 0, mH = 0;
      var hasStroke = false, hasFill = false;

      function sizeMasks() {
        var w = Math.ceil(el.offsetWidth * MASK_SCALE);
        var h = Math.ceil(el.offsetHeight * MASK_SCALE);
        if (w === mW && h === mH) return;
        mW = w; mH = h;
        sCvs.width = w; sCvs.height = h;
        fCvs.width = w; fCvs.height = h;
        sCtx.fillStyle = 'white';
        fCtx.fillStyle = 'white';
        hasStroke = false; hasFill = false;
      }

      function paint(ctx, x, y) {
        var r = BASE_RADIUS * MASK_SCALE;
        ctx.beginPath();
        ctx.arc(x * MASK_SCALE, y * MASK_SCALE, r, 0, 6.2832);
        ctx.fill();
      }

      function pushMask(layers, cvs) {
        var url = cvs.toDataURL();
        for (var i = 0; i < layers.length; i++) {
          layers[i].style.webkitMaskImage = 'url(' + url + ')';
          layers[i].style.maskImage = 'url(' + url + ')';
          layers[i].style.webkitMaskSize = '100% 100%';
          layers[i].style.maskSize = '100% 100%';
        }
      }

      function clearMaskCSS(layers) {
        for (var i = 0; i < layers.length; i++) {
          layers[i].style.webkitMaskImage = '';
          layers[i].style.maskImage = '';
        }
      }

      /* visibility */
      var fadeDelayTimer = null, cleanupTimer = null;
      var strokeVis = false, fillVis = false;
      var pressing = false;
      var rafId = null, sDirty = false, fDirty = false;

      function flush() {
        rafId = null;
        if (sDirty && hasStroke) { pushMask(strokeLayers, sCvs); sDirty = false; }
        if (fDirty && hasFill)   { pushMask(fillLayers, fCvs);   fDirty = false; }
      }
      function schedule() { if (!rafId) rafId = requestAnimationFrame(flush); }

      function showS() {
        if (strokeVis) return; strokeVis = true;
        for (var i = 0; i < strokeLayers.length; i++) {
          strokeLayers[i].style.transition = 'opacity 0.15s ease';
          strokeLayers[i].style.opacity = '1';
        }
      }
      function showF() {
        if (fillVis) return; fillVis = true;
        for (var i = 0; i < fillLayers.length; i++) {
          fillLayers[i].style.transition = 'opacity 0.15s ease';
          fillLayers[i].style.opacity = '1';
        }
      }
      function fadeAll() {
        strokeVis = false; fillVis = false;
        for (var i = 0; i < allLayers.length; i++) {
          allLayers[i].style.transition = 'opacity ' + FADE_DURATION + 'ms ease';
          allLayers[i].style.opacity = '0';
        }
      }
      function clrTimers() {
        if (fadeDelayTimer) { clearTimeout(fadeDelayTimer); fadeDelayTimer = null; }
        if (cleanupTimer)  { clearTimeout(cleanupTimer);  cleanupTimer = null; }
      }
      function cancelFade() {
        clrTimers();
        if (!strokeVis && hasStroke) showS();
        if (!fillVis && hasFill) showF();
      }

      el.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        pressing = true;
        cancelFade(); sizeMasks();
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left, y = e.clientY - rect.top;
        paint(fCtx, x, y); hasFill = true; fDirty = true;
        paint(sCtx, x, y); hasStroke = true; sDirty = true;
        schedule(); showS(); showF();
      });

      document.addEventListener('mouseup', function (e) {
        if (e.button !== 0) return;
        pressing = false;
      });

      el.addEventListener('mouseenter', function () {
        cancelFade(); sizeMasks();
      });

      el.addEventListener('mousemove', function (e) {
        cancelFade(); sizeMasks();
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left, y = e.clientY - rect.top;
        paint(sCtx, x, y); hasStroke = true; sDirty = true; showS();
        if (pressing) {
          paint(fCtx, x, y); hasFill = true; fDirty = true; showF();
        }
        schedule();
      });

      el.addEventListener('mouseleave', function () {
        pressing = false;
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        if (sDirty && hasStroke) { pushMask(strokeLayers, sCvs); sDirty = false; }
        if (fDirty && hasFill)   { pushMask(fillLayers, fCvs);   fDirty = false; }
        clrTimers();
        fadeDelayTimer = setTimeout(function () {
          fadeDelayTimer = null;
          fadeAll();
          cleanupTimer = setTimeout(function () {
            cleanupTimer = null;
            hasStroke = false; hasFill = false;
            sCtx.clearRect(0, 0, mW, mH);
            fCtx.clearRect(0, 0, mW, mH);
            clearMaskCSS(strokeLayers);
            clearMaskCSS(fillLayers);
          }, FADE_DURATION + 50);
        }, FADE_DELAY);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  var url = new URL(window.location.href);
  if (url.hash) {
    /* Start at top so the user sees the gallery, then smooth-scroll to target */
    if (history.scrollRestoration) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        var target = document.getElementById(url.hash.slice(1));
        if (target) {
          requestAnimationFrame(function () {
            target.scrollIntoView({ behavior: 'smooth' });
          });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["releases-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(max-width: 749px)').matches) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const releases = document.querySelectorAll('.releases-list__release');
    if (releases.length < 2) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const prev = entry.target.previousElementSibling;
          if (!prev || !prev.classList.contains('releases-list__release')) return;

          var ratio = entry.intersectionRatio;

          if (!entry.isIntersecting || ratio < 0.1) {
            prev.classList.remove('is-leaving', 'is-leaving--deep');
          } else if (ratio >= 0.7) {
            prev.classList.add('is-leaving', 'is-leaving--deep');
          } else {
            prev.classList.add('is-leaving');
            prev.classList.remove('is-leaving--deep');
          }
        });
      },
      { threshold: [0, 0.1, 0.3, 0.5, 0.7, 0.85] }
    );

    Array.from(releases).slice(1).forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-gallery"]) return;
  try {
    
  (function () {
    var wrap = document.querySelector('.story-gallery__grid-wrap');
    if (!wrap) return;

    var grid = wrap.querySelector('.story-gallery__grid');
    var btn = wrap.querySelector('.story-gallery__expand-toggle');
    var items = grid.querySelectorAll('.story-gallery__item');

    /* Determine how many columns are visible at the current breakpoint */
    function getColumns() {
      if (window.matchMedia('(min-width: 990px)').matches) return 4;
      if (window.matchMedia('(min-width: 750px)').matches) return 3;
      return 2;
    }

    var collapsedH = 0;

    function measure() {
      var cols = getColumns();
      /* If total images fit in 1 row, no need to collapse */
      if (items.length <= cols) {
        wrap.classList.remove('is-collapsed');
        if (btn) btn.style.display = 'none';
        return;
      }

      /* Temporarily expand to measure first row height */
      wrap.classList.remove('is-collapsed');
      wrap.style.maxHeight = 'none';

      var gridRect = grid.getBoundingClientRect();
      /* Measure the bottom of the last item in the first row */
      var lastInRow = items[cols - 1];
      collapsedH = lastInRow.getBoundingClientRect().bottom - gridRect.top;
      wrap.style.setProperty('--gallery-collapsed-h', collapsedH + 'px');

      wrap.style.maxHeight = '';
      wrap.classList.add('is-collapsed');
      if (btn) btn.style.display = '';
    }

    /* If arriving via #gallery hash, skip collapse */
    var hashExpanded = window.location.hash === '#gallery';

    if (!btn || items.length <= 2) {
      if (btn) btn.remove();
      return;
    }

    if (hashExpanded) {
      wrap.classList.remove('is-collapsed');
      btn.style.display = 'none';
      /* Scroll to the very top so the page starts at the beginning */
      history.replaceState(null, '', window.location.pathname + window.location.search);
      requestAnimationFrame(function () { window.scrollTo(0, 0); });
    } else {
      measure();
    }

    btn.addEventListener('click', function () {
      var fullH = grid.scrollHeight;

      wrap.style.maxHeight = collapsedH + 'px';
      wrap.style.transition = 'none';
      wrap.offsetHeight; /* reflow */

      wrap.style.transition = 'max-height 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
      wrap.style.maxHeight = fullH + 'px';
      wrap.classList.remove('is-collapsed');

      btn.style.opacity = '0';
      btn.style.transition = 'opacity 0.3s ease';

      wrap.addEventListener(
        'transitionend',
        function () {
          wrap.style.maxHeight = '';
          wrap.style.transition = '';
          btn.style.display = 'none';
          btn.style.opacity = '';
        },
        { once: true }
      );
    });

    /* Handle resize / orientation change */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!wrap.classList.contains('is-collapsed') && btn.style.display === 'none') return;
        measure();
      }, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
